export const CORNER_OFFSET = 8;
export const CONNECTING_BORDER_SIZE = 8;
export const CONNECTING_BORDER_STYLE = "butt";
export const CONNECTING_BORDER_OPACITY = 0.1;
export const CONNECTING_BORDER_STROKE = "gray";
